import BookingWizard from "@/components/BookingWizard";

const BookingPage = () => <BookingWizard />;

export default BookingPage;
